// extracted by mini-css-extract-plugin
export default {"slider":"slider---eZ_AG"};